import { Params } from '@angular/router';

export function getRedirectBackUrl(href: string): string {
  if (!href) {
    return '';
  }
  return href.replace(/^(http|https).\/\/(.*?)\//g, '');
}

/**
 * Removes all special characters and trims the query
 */
export function getValidSearchQuery(searchQuery: unknown, replacement = ' '): string {
  if (typeof searchQuery === 'string') {
    // https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
    return searchQuery.replace(/[.+§*?^$()[\]{}:!]/g, replacement).trim();
  }
  return '';
}

export function parseURLSearchParams(searchStr: string): Params {
  const queryParams: Params = {};
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(searchStr);
    searchParams.forEach((val, key) => {
      queryParams[key] = parseValue(val);
    });
  }
  return queryParams;
}

// Helper function to parse a string value into its proper type
function parseValue(value: string): string | number | boolean | null {
  if (value === '') {
    return value;
  }
  if (value === 'null') {
    return null;
  }
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  // Check for purely numeric strings (no leading zeros)
  if (/^-?\d+$/.test(value) && !/^0\d/.test(value)) {
    return Number(value); // Convert valid numeric strings to numbers
  }
  return value; // Default to string
}
